import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';
import { categories } from '@/mocks/comics';

function getCategoryName(slug: string): string {
  const cat = categories.find(c => c.slug === slug);
  return cat ? cat.name : slug;
}

export default function FeaturedSection() {
  const featured = comics.filter(c => c.isRecommended).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              推荐作品
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              编辑精选的高品质韩国漫画
            </p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              cover={comic.cover}
              category={comic.category}
              categoryName={getCategoryName(comic.category)}
              rating={comic.rating}
              chapters={comic.chapters}
              status={comic.status}
              isHot={comic.isHot}
              isNew={comic.isNew}
              views={comic.views}
            />
          ))}
        </div>
      </div>
    </section>
  );
}